
class AlarmRuleUtils {

    public static getRuleAbbriviation(alarmRule: any) {
        let operator = alarmRule.operator;
        switch (operator.toUpperCase()) {
            case 'GT':
                return `>${alarmRule.threshold}`;
            case 'GTE':
                return `≥${alarmRule.threshold}`;
            case 'LT':
                return `<${alarmRule.threshold}`;
            case 'LTE':
                return `≤${alarmRule.threshold}`;
            case 'EQ':
                return `=${alarmRule.threshold}`;
            case 'CUSTOMIZED':
                return alarmRule.expression;
            default:
                return '';
        }
    }

    public static getTypeName(type: string) {
        if (type == 'DEVICE_TEMPLATE') {
            return '设备模板';
        } else if (type == 'DEVICE') {
            return '设备';
        }
        return '';
    }

}

export default AlarmRuleUtils;
